import React from 'react';
import { Col, Container, Row, Form, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ThreadComponent from '../ThreadComponent';
import { WithRouter } from '../../../helpers/Router';
import URI from '../../../defaults/RoutesDefault';
import Header from '../../components/Header';
import ListFilter from '../../components/ListFilter';
import { ApiService } from '../../../lib/api/HttpService';
import Select from 'react-select';
import DeleteModal from '../../../app/components/modal/DeleteModal';
import HandleDeleteWorker from '../../../utilities/DeleteWorker';
import {
	displayAlertError,
	displayAlertLoader,
	displayAlertSuccess,
	hideAlertLoader,
} from '../../../utilities/Response';
import MSG from '../../../defaults/Message';
import FilterSort from '../../../utilities/modules/FilterSort';
import AsyncClientsDropdown from '../../../app/components/dropdowns/AsyncClientsDropdown';
import AsyncEmployeesDropdown from '../../../app/components/dropdowns/AsyncEmployeesDropdown';
import { SECURITY_ATTRIBUTE_TYPES } from '../../../app/context/security';
import SecureBootstrapButton from '../../../app/components/security/SecureBootstrapButton';
import {
	renderSecureContent,
	renderSecureHideContent,
} from '../../../utilities/modules/SecureContent';
import { ProjectTable } from './ProjectTable';
import './ProjectList.css';
import { useQueryClient } from '@tanstack/react-query';
import { ECacheKeys } from 'cache/CacheKeys';
import { getCookie } from 'legacy/utilities/Auth';

const WithQueryClient = (WrappedComponent) => {
	return function WithQueryClient(props) {
		const queryClient = useQueryClient();
		return <WrappedComponent {...props} queryClient={queryClient} />;
	};
};

const instanceId = getCookie('dmInstanceId');

class ProjectList extends ThreadComponent {
	constructor(props) {
		super(props);
		this.fs = new FilterSort('project_list');
		this.state = {
			checks: {},
			data: [],
			enableFilters:
				(localStorage.getItem(`${instanceId}-projects-list-filter`) &&
					JSON.parse(
						localStorage.getItem(`${instanceId}-projects-list-filter`)
					).find((item) => item.id === 'enableFilters')?.value) ||
				false,
			selectedProjects: {},
			dataIsLoaded: false,
			status: [
				{ value: '', label: 'All' },
				{ value: 'closed', label: 'Closed' },
				{ value: 'open', label: 'Open' },
			],
			statusFilter: this.fs.getFilter('statusFilter') ?? {
				value: 'open',
				label: 'Open',
			},
			clientFilter: this.fs.getFilter('clientFilter') ?? {
				value: '',
				label: 'All',
			},
			managerFilter: this.fs.getFilter('managerFilter') ?? {
				value: '',
				label: 'All',
			},
			showModal: false,
			deleteResponses: [],
		};
		this.api = new ApiService();
	}

	componentInit() {
		this.setTitle('Projects').setActionBar(true);
	}

	toggleNumberModal = (e) => {
		this.setState({
			showNumberModal: !this.state.showNumberModal,
		});
	};

	handleShowTableSearch = () => {
		this.setState({
			enableFilters: !this.state.enableFilters,
		});
	};

	handleCancel = async () => {
		this.handleTestDeleteObjects(true);
	};

	async handleClose() {
		if (!Object.keys(this.state.checks).length) {
			return;
		}

		displayAlertLoader(MSG.loading.prepare.item);
		try {
			let index = 0;
			for (const id of Object.keys(this.state.checks)) {
				const params = {
					closeddt: new Date(),
					proj: this.state.selectedProjects[index],
				};
				await this.api.editProject(Number(id), params);
				index++;
			}

			hideAlertLoader();

			setTimeout(() => {
				let itemMsg = this.state.checks.length > 1 ? 'items' : 'item';
				displayAlertSuccess('Successfully closed an ' + itemMsg);

				this.refreshDataAfterDelete();
			});
		} catch (error) {
			displayAlertError(error.response.data.userError);
		}
	}

	async handleTestDeleteObjects(deactivateOnly) {
		if (!Object.keys(this.state.checks).length) {
			return;
		}

		let workers = [];

		displayAlertLoader(MSG.loading.prepare.item);

		for (const id of Object.keys(this.state.checks)) {
			const params = {
				deleteType: 'dmriTestOnly',
				objectType: 'objProject',
				objectCodeOrId: Number(id),
			};
			workers.push(await this.api.postJson('deleteobjects', params));
		}

		hideAlertLoader();
		if (workers) {
			HandleDeleteWorker(
				workers,
				{
					moduleSingular: 'Project',
					modulePlural: 'Projects',
					reference: '',
					objectType: 'objProject',
				},
				deactivateOnly,
				(modalState) => {
					this.setState(modalState);
				}
			);
		}
	}

	refreshDataAfterDelete = (e) => {
		this.props.queryClient.resetQueries({
			queryKey: [ECacheKeys.Projects],
		});

		this.setState({
			checks: {},
			showModal: false,
			deleteResponses: [],
		});
	};

	renderHeader() {
		return (
			<Header>
				<Header.Title>Projects</Header.Title>
				<Header.Actions list={true}>
					<li>
						<SecureBootstrapButton
							attributeNo={13}
							attributeType={SECURITY_ATTRIBUTE_TYPES.DenyAdd}
							as={Link}
							to={URI.project.add}
							variant="light"
							size="lg"
							className="btn-icon text-secondary-green"
							data-testid="btn-add-project"
						>
							<i className="ri-add-line ri-lg"></i> Add
						</SecureBootstrapButton>
					</li>
				</Header.Actions>
			</Header>
		);
	}

	getRowSelection = (rows, projectIds) => {
		this.setState({
			checks: rows,
			selectedProjects: projectIds,
		});
	};

	handleFilter = (name) => (e) => {
		this.setState({
			[name]: e,
		});
		this.fs.setFilter(name, e);
	};

	renderFilters() {
		return renderSecureHideContent(
			<>
				<ListFilter className="project-list-filter">
					<ListFilter.Fields md={12} lg={8} xl={9} className="width-30">
						<ListFilter.Field>
							<Form.Label className="text-end">
								<strong>Client</strong>
							</Form.Label>
							<AsyncClientsDropdown
								onChange={this.handleFilter('clientFilter')}
								styles={{
									container: (provided) => ({
										...provided,
										width: '100%',
									}),
								}}
								defaultValue={this.state.clientFilter}
								className="react-select"
								placeholder="Please select"
								prependOptions={[
									{
										label: 'All',
										value: '',
									},
								]}
							/>
						</ListFilter.Field>
						<ListFilter.Field>
							<Form.Label className="text-end">
								<strong>Salesperson</strong>
							</Form.Label>
							<AsyncEmployeesDropdown
								onChange={this.handleFilter('managerFilter')}
								styles={{
									container: (provided) => ({
										...provided,
										width: '100%',
									}),
								}}
								defaultValue={this.state.managerFilter}
								className="react-select"
								placeholder="Please select"
								prependOptions={[
									{
										label: 'All',
										value: '',
									},
								]}
							/>
						</ListFilter.Field>
						<ListFilter.Field>
							<Form.Label className="text-end">
								<strong>Show</strong>
							</Form.Label>
							<Select
								onChange={this.handleFilter('statusFilter')}
								styles={{
									container: (provided) => ({
										...provided,
										width: '100%',
									}),
								}}
								key={`${Math.floor(Math.random() * 1000)}-min`}
								options={this.state.status}
								defaultValue={this.state.statusFilter}
								className="react-select"
								placeholder="Please select"
							/>
						</ListFilter.Field>
					</ListFilter.Fields>
					<ListFilter.Actions
						md={12}
						lg={4}
						xl={3}
						className="justify-content-center"
					>
						<ListFilter.Action className="">
							<Button
								as={Link}
								to="#"
								variant="ivory"
								size="sm"
								className={`btn-icon btn-action me-3 ${
									this.state.enableFilters ? 'bg-primary-ash text-white' : ''
								}`}
								onClick={this.handleShowTableSearch}
								data-testid="search-project-button"
							>
								<i className="ri-search-line"></i> Search
							</Button>
							<SecureBootstrapButton
								attributeNo={13}
								attributeType={SECURITY_ATTRIBUTE_TYPES.DenyDel}
								href="#"
								to="#"
								variant="ivory"
								size="sm"
								className="btn-icon btn-action me-3"
								disabled={!Object.keys(this.state.checks).length}
								onClick={this.handleClose.bind(this)}
							>
								<i className="ri-door-closed-fill"></i> Close
							</SecureBootstrapButton>
							<SecureBootstrapButton
								attributeNo={13}
								attributeType={SECURITY_ATTRIBUTE_TYPES.DenyDel}
								data-testid="delete-project-button"
								href="#"
								to="#"
								variant="ivory"
								size="sm"
								className="btn-icon btn-action"
								disabled={!Object.keys(this.state.checks).length}
								onClick={this.handleTestDeleteObjects.bind(this, false)}
							>
								<i className="ri-close-line"></i> Delete
							</SecureBootstrapButton>
						</ListFilter.Action>
					</ListFilter.Actions>
				</ListFilter>
				<ListFilter.Spacer />
			</>
		)(13, SECURITY_ATTRIBUTE_TYPES.DenyAccess);
	}

	render() {
		return renderSecureContent(
			<>
				{this.renderHeader()}
				<div className="content-padding has-action-bar sticky-container">
					<Container fluid className="px-0">
						<Row>
							<Col sm="12">
								{this.renderFilters()}
								<ProjectTable
									clientFilter={this.state.clientFilter?.value}
									managerFilter={this.state.managerFilter?.value}
									statusFilter={this.state.statusFilter?.value}
									sendRowSelection={this.getRowSelection}
									enableFilters={this.state.enableFilters}
								/>
							</Col>
						</Row>
					</Container>
				</div>
				<DeleteModal
					refreshData={this.refreshDataAfterDelete.bind(this)}
					show={this.state.showModal}
					hideModal={() => this.setState((prev) => (prev.showModal = false))}
					responses={this.state.deleteResponses}
				/>
			</>
		)(13, SECURITY_ATTRIBUTE_TYPES.DenyAccess);
	}
}

export default WithRouter(WithQueryClient(ProjectList));
